// api/printheadUpdate.js
export const updatePrinthead = async (caseID, printheadCode) => {
    try {
        const response = await fetch('/phpsc-backend/api/v1/printhead', {
            method: 'PATCH',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                CaseID: caseID,
                PrintheadCode: printheadCode,
            }).toString(),
        });

        if (!response.ok) {
              if (response.status === 403) {


                           console.warn('🔒 Token expired or unauthorized. Logging out...');

                             // Optional: clear auth token manually
                             document.cookie = 'auth-token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;';

                             // Optional: clear localStorage if needed
                             localStorage.removeItem('redirectURL');

                             // Force a full reload or redirect to login
                             window.location.reload();

                         }
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error("Error updating printhead:", error);
        throw error;
    }
};
